import { absolutePath } from "../../absolutePath";
import { accessGroupsMigration } from "./accessGroupsMigration";
import { affiliates } from "./affiliates";

interface PaywallsFnProps {
  chargeId?: string | number;
  couponCode?: string | number;
  id?: string | number;
  params?: Record<string, unknown>;
  subscriptionId?: string | number;
}

export const paywalls = {
  communityMembers: {
    billing: {
      index: (params: Record<string, unknown> = {}) =>
        absolutePath("admin/paywalls/community_members/billing", params),
    },
  },
  exports: {
    create: () => absolutePath("admin/paywalls/exports"),
  },
  subscriptions: {
    index: ({ params = {} }: PaywallsFnProps = {}) =>
      absolutePath("admin/paywalls/subscriptions", params),
    create: () => absolutePath("admin/paywalls/subscriptions"),
    refundOptions: ({ subscriptionId }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/subscriptions/${subscriptionId}/refund_options`,
      ),
    cancellations: ({ subscriptionId, params = {} }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/subscriptions/${subscriptionId}/cancellations`,
        params,
      ),
    coupons: {
      create: ({ subscriptionId }: PaywallsFnProps = {}) =>
        absolutePath(`admin/paywalls/subscriptions/${subscriptionId}/coupons`),
      delete: ({ subscriptionId }: PaywallsFnProps = {}) =>
        absolutePath(`admin/paywalls/subscriptions/${subscriptionId}/coupons`),
      preview: ({ subscriptionId, couponCode }: PaywallsFnProps = {}) =>
        absolutePath(
          `admin/paywalls/subscriptions/${subscriptionId}/coupons/preview`,
          couponCode ? { coupon_code: couponCode } : {},
        ),
    },
    billingDate: ({ subscriptionId }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/subscriptions/${subscriptionId}/billing_date`,
      ),
  },
  charges: {
    index: ({ params = {} }: PaywallsFnProps = {}) =>
      absolutePath("admin/paywalls/charges", params),
    refunds: ({ chargeId, params = {} }: PaywallsFnProps = {}) =>
      absolutePath(`admin/paywalls/charges/${chargeId}/refunds`, params),
  },
  taxSettings: {
    show: () => absolutePath("admin/paywalls/tax_settings"),
    update: () => absolutePath("admin/paywalls/tax_settings"),
  },
  paymentMethodPreferences: {
    show: () => absolutePath("admin/paywalls/payment_method_preferences"),
    update: () => absolutePath("admin/paywalls/payment_method_preferences"),
  },
  affiliates,
  accessGroupsMigration,
};
